import { useOutletContext } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Users, Calendar, Trophy, Newspaper, Image, MessageSquare, TrendingUp } from 'lucide-react';

export default function AdminDashboard() {
  const { stats } = useOutletContext();

  const cards = [
    { icon: Users, label: 'Atletas', value: stats?.atletas || 0, color: 'bg-blue-500' },
    { icon: Calendar, label: 'Eventos', value: stats?.eventos || 0, color: 'bg-green-500' },
    { icon: Trophy, label: 'Conquistas', value: stats?.conquistas || 0, color: 'bg-yellow-500' },
    { icon: Newspaper, label: 'Notícias', value: stats?.noticias || 0, color: 'bg-purple-500' },
    { icon: Image, label: 'Fotos', value: stats?.fotos || 0, color: 'bg-pink-500' },
    { icon: MessageSquare, label: 'Contatos Novos', value: stats?.contatos_nao_lidos || 0, color: 'bg-red-500' },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <h1 className="font-heading text-3xl font-bold text-slate-900">Dashboard</h1>
        <p className="text-slate-600 mt-1">Visão geral do site ACEC Feminino</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map((card, index) => (
          <motion.div
            key={card.label}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05 }}
            className="bg-white rounded-xl p-6 shadow-sm"
            data-testid={`stat-card-${card.label.toLowerCase().replace(' ', '-')}`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-500 text-sm font-medium">{card.label}</p>
                <p className="font-accent text-4xl font-bold text-slate-900 mt-1">
                  {card.value}
                </p>
              </div>
              <div className={`w-12 h-12 ${card.color} rounded-lg flex items-center justify-center`}>
                <card.icon className="w-6 h-6 text-white" />
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="mt-8 bg-white rounded-xl p-6 shadow-sm">
        <h2 className="font-heading text-xl font-bold text-slate-900 mb-4">
          Ações Rápidas
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <a
            href="/admin/atletas"
            className="p-4 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors text-center"
            data-testid="quick-action-atletas"
          >
            <Users className="w-8 h-8 mx-auto text-blue-600 mb-2" />
            <span className="text-sm font-medium text-slate-700">Adicionar Atleta</span>
          </a>
          <a
            href="/admin/eventos"
            className="p-4 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors text-center"
            data-testid="quick-action-eventos"
          >
            <Calendar className="w-8 h-8 mx-auto text-green-600 mb-2" />
            <span className="text-sm font-medium text-slate-700">Criar Evento</span>
          </a>
          <a
            href="/admin/galeria"
            className="p-4 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors text-center"
            data-testid="quick-action-galeria"
          >
            <Image className="w-8 h-8 mx-auto text-pink-600 mb-2" />
            <span className="text-sm font-medium text-slate-700">Upload de Fotos</span>
          </a>
          <a
            href="/admin/contatos"
            className="p-4 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors text-center"
            data-testid="quick-action-contatos"
          >
            <MessageSquare className="w-8 h-8 mx-auto text-red-600 mb-2" />
            <span className="text-sm font-medium text-slate-700">Ver Mensagens</span>
          </a>
        </div>
      </div>
    </div>
  );
}
